// Converts camelCase → kebab-case
export const toKebab = (str) =>
    str.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();

// Converts a JS style object into a CSS string
export const styleObjectToCss = (styleObj = {}) =>
    Object.entries(styleObj)
        .map(([key, value]) => {
            if (value == null) return '';

            const prop = toKebab(key);

            // if value is a number, add px (except 0)
            const val =
                typeof value === 'number' && value !== 0 ? `${value}px` : value;

            return `${prop}: ${val};`;
        })
        .join('\n');